// ----------------------------------------------------------------------------------------
// Do not edit this file, it is auto-generated by scripts/generate-version.js
// ----------------------------------------------------------------------------------------
export const APP_VERSION_INFO = Object.freeze({
  NAME: "noa-ui",
  DESCRIPTION: "Webapp that helps create accurate project quotations using AI",
  REPOSITORY: "https://github.com/Baseline-quebec/NOA-sfppn",
  AUTHOR: "Lichens Innovation",
  VERSION: "1.0.0",
  VERSION_DATE: "2025-10-22",
  VERSION_DATE_ISO: "2025-10-22T16:48:05.442Z",
});

export const LONG_VERSION_DATE = "1.0.0 (2025-10-22)";
